export const SUPPORT_NUMBER = { text: '0207 118  4502', phone: '02071184502' };
export const SUPPORT_EMAIL = 'support@showshoppa.com';
export const DEFAULT_PAGING_DISPLAYED_RANGE = 11;
export const SHOPNET_SHOP_ID = 1000000;
